export enum ComplaintsStatuses {
  Open = 'Open',
  InProgress = 'InProgress',
  Accepted = 'Accepted',
  Rejected = 'Rejected'
}

export interface IComplaintStatus {
  id: ComplaintsStatuses;
  value: string;
}

export const ComplaintsStatusesList: IComplaintStatus[] = [
  { id: ComplaintsStatuses.Open, value: 'Offen' },
  { id: ComplaintsStatuses.InProgress, value: 'In Arbeit' },
  { id: ComplaintsStatuses.Accepted, value: 'Erledigt' },
  { id: ComplaintsStatuses.Rejected, value: 'Abgelehnt' }
];

type StatusColors = {
  [key in ComplaintsStatuses]: string;
};

export const ComplaintsStatusesColors: StatusColors = {
  [ComplaintsStatuses.Open]: 'blue',
  [ComplaintsStatuses.InProgress]: 'orange',
  [ComplaintsStatuses.Accepted]: 'green',
  [ComplaintsStatuses.Rejected]: 'red'
};

export const getStatusColor = (status: ComplaintsStatuses): string =>
  ComplaintsStatusesColors[status] || 'default';

export const getStatusLabel = (status: ComplaintsStatuses): string => {
  const statusItem = ComplaintsStatusesList.find(item => item.id === status);
  return statusItem?.value || status;
};
